import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, tap, catchError } from 'rxjs';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;
const checkIfFile = (value:any) => {
  return value instanceof File;
};
@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService,) { }
    
      createItem(data: any): Observable<any> {
        let formData:FormData=null;
        
        formData=this.FormDataByObject(data,'image');
        formData.append('image',data.image);
        return this.http.post<any>(`${apiurl}/question`, formData).pipe(
          tap((response) => response),
          catchError((error) => this.errorHandler.handleError(error))
        );
      }
    
      getItemsByQuizId(data:any): Observable<any> {
        return this.http.get<any>(`${apiurl}/question/byQuizId/${data.id}`).pipe(
          tap((response) => response),
          catchError((error) => this.errorHandler.handleError(error))
        );
      }

    getItems(param: HttpParams = null): Observable<any> {
          return this.http.get<any>(`${apiurl}/question`, { params: param }).pipe(
            tap((response) => response),
            catchError((error) => this.errorHandler.handleError(error))
          );
        }
    
      updateItem(data: any): Observable<any> {
        console.log(data);
        let formData:FormData=null;
        if(checkIfFile(data.image)){
          formData=this.FormDataByObject(data,'image');
          formData.append('image',data.image);
        }
        return this.http.put<any>(`${apiurl}/question/${data.id}`, checkIfFile(data.image)?formData:data).pipe(
          tap((response) => response),
          catchError((error) => this.errorHandler.handleError(error))
        );
      }

      FormDataByObject(obj: any,prop:string): FormData {
        const data = new FormData();
        Object.keys(obj).forEach((key) => {
          if(key!==prop){
            const value = obj[key];
      
          if (Array.isArray(value)) {
            data.append(key, JSON.stringify(value));
          } else if (typeof value === 'object' && value !== null) {
            data.append(key, JSON.stringify(value));
          } else {
            data.append(key, value === null ? '' : value);
          }
          }
        });
        return data;
      }
}
